import { forwardRef, type ButtonHTMLAttributes } from 'react';
import { cn } from '@/lib/utils';

type Variant = 'primary' | 'secondary' | 'text';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
}

const base =
  'inline-flex items-center justify-center gap-2 rounded-md font-sans text-sm font-bold uppercase tracking-widest transition-[color,background-color,transform] duration-200 ease-out will-change-transform focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:pointer-events-none disabled:opacity-50';

const variants: Record<Variant, string> = {
  primary: 'bg-primary text-primary-foreground hover:bg-primary/90 px-6 py-3',
  secondary: 'border border-secondary text-secondary-foreground bg-transparent hover:bg-secondary/10 px-6 py-3',
  text: 'text-primary underline underline-offset-4 hover:text-primary/80 bg-transparent px-2 py-1'
};

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, variant = 'primary', ...props }, ref) => (
    <button ref={ref} className={cn(base, variants[variant], className)} {...props} />
  )
);
Button.displayName = 'Button';
